import React from 'react';
import PropTypes from 'prop-types';
import { LargeMobile } from 'Responsive';
import CalculatorInput from 'CalculatorInput';
import TotalView from './TotalView';

const ExpenseInputs = props => (
  <React.Fragment>
    <CalculatorInput
      title="Legal"
      description={'Money spent on legal fees related to establishing the business, registrations, licenses, trademarking, etc.'}
      onChange={e => props.onChange(e, 0)}
      value={props.values[0]}
      className="startup-calculator-input-wrap"
      type="monetary"
    />
    <CalculatorInput
      title="Design"
      description={'Money spent on design for the business including a professional logo and website design.'}
      onChange={e => props.onChange(e, 1)}
      value={props.values[1]}
      className="startup-calculator-input-wrap"
      type="monetary"
    />
    <CalculatorInput
      title="Space"
      description={'Expenses that occur related to the space your business will occupy. Insurance on your office and on inventory, security deposit and rent you pay before opening your doors.'}
      onChange={e => props.onChange(e, 2)}
      value={props.values[2]}
      className="startup-calculator-input-wrap"
      type="monetary"
    />
    <CalculatorInput
      title="Equipment"
      description={'Computer and office equipment (which are important startup costs as the IRS allows a certain amount of these costs to be deducted), software and other technology expenses.'}
      onChange={e => props.onChange(e, 3)}
      value={props.values[3]}
      className="startup-calculator-input-wrap"
      type="monetary"
    />
    <CalculatorInput
      title="Employees"
      description={'Cost of training employees, and pay for employees who are working before you are open for business (payroll).'}
      onChange={e => props.onChange(e, 4)}
      value={props.values[4]}
      className="startup-calculator-input-wrap"
      type="monetary"
    />
    <CalculatorInput
      title="Marketing"
      description={'Pre-launch marketing expenses including advertising expenses on social media channels, television, radio, print signs, etc.'}
      onChange={e => props.onChange(e, 5)}
      value={props.values[5]}
      className="startup-calculator-input-wrap"
      type="monetary"
    />
    <CalculatorInput
      title="Other Costs"
      description=""
      onChange={e => props.onChange(e, 6)}
      value={props.values[6]}
      className="startup-calculator-input-wrap startup-calculator-final-input"
      type="monetary"
    />
    <LargeMobile>
      <TotalView
        title="Total Expenses"
        sum={props.sum}
        back={props.back}
        next={props.next}
        nextText="Assets"
      />
    </LargeMobile>
  </React.Fragment>
);

ExpenseInputs.defaultProps = {
  back: null,
  next: null,
};

ExpenseInputs.propTypes = {
  onChange: PropTypes.func.isRequired,
  values: PropTypes.arrayOf(PropTypes.string).isRequired,
  sum: PropTypes.string.isRequired,
  back: PropTypes.func,
  next: PropTypes.func,
};

export default ExpenseInputs;



// WEBPACK FOOTER //
// ./src-react/StartupCalculator/components/ExpenseInputs.jsx